import styled from 'styled-components'

import { PageWorkflowStatus } from 'shared/types/global'

import { PAGE_STATUS_GRADIENTS } from './constants'

const DEFAULT_SIZE = 16

export const Bubble = styled.div<{
  status: PageWorkflowStatus
  size: number
}>`
  width: ${({ size }) => size ?? DEFAULT_SIZE}px;
  height: ${({ size }) => size ?? DEFAULT_SIZE}px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ status, theme }) =>
    PAGE_STATUS_GRADIENTS[status] || theme.color.base.c3};
  border: 1px solid ${({ theme }) => theme.color.base.c2};
  box-sizing: border-box;
  transition: background 0.2s ease;
`
